// typewriter.js
export default function registerIndexTypewriter(Alpine) {
  Alpine.data("realEstateTypewriter", () => ({
    fullText: "handled end to end",
    currentText: "",
    charIdx: 0,
    isDeleting: false,
    typeSpeed: 140,
    cycle: 1, // 1 = delete everything, 2 = delete back to "handled"
    ready: false,

    init() {
      this.ready = true;
      this.type();
    },

    type() {
      // How far to erase on this cycle: cycle 1 -> 0, cycle 2 -> "handled".length
      const deleteFloor = this.cycle === 1 ? 0 : "handled ".length;

      if (!this.isDeleting) {
        this.charIdx++;
        this.currentText = this.fullText.substring(0, this.charIdx);
        this.typeSpeed = 140;
      } else {
        this.charIdx--;
        this.currentText = this.fullText.substring(0, this.charIdx);
        this.typeSpeed = 65;
      }

      // Fully typed -> hold, then delete
      if (!this.isDeleting && this.currentText === this.fullText) {
        this.typeSpeed = this.cycle === 1 ? 4500 : 3000; // longer hold after cycle 1
        this.isDeleting = true;
      }
      // Reached this cycle's delete floor -> hold, then retype
      else if (this.isDeleting && this.charIdx === deleteFloor) {
        this.isDeleting = false;
        this.cycle = this.cycle === 1 ? 2 : 1; // alternate cycles
        this.typeSpeed = 600;
      }

      setTimeout(() => this.type(), this.typeSpeed);
    },
  }));
}
